import { gql } from '@apollo/client';

const RequestAccessFragments = {
  PublicListing: gql`
    fragment RequestAccessPublicListing on PublicListing {
      id
      name
      last_updated_date
      created_date
      loan_count
      pricing_type
      servicing_preference
      servicing_fee_rate_bps
      top_states
      t_current_balance_cents
      wa_borrower_credit_score
      wa_coupon_bps
      wa_current_balance_cents
      wa_dti_bps
      wa_loan_age_months
      wa_remaining_loan_terms_months
      wa_ltv_bps
      participation_rate
      in_progress_deal_id
      company {
        ... on UserCompany {
          id
        }
      }
    }
  `,
};

export { RequestAccessFragments };
